<template>
  <div class="main">
    <sh-search :is-show="selectTypeShow" @onClick="selectTypeShow = true" @onCancel="searchCancel" @submitSearch="submitSearch"> </sh-search>
    <div class="search-bar">
      <div class="search-type" v-if="selectTypeShow">
        <div class="radio-group">
          <mt-radio v-model="radioSelect" align="right" :options="radioOptions"> </mt-radio>
        </div>
        <div class="mask" @click="selectTypeShow = false"></div>
      </div>
    </div>
    <!-- list -->
    <div class="balance-mian" v-infinite-scroll="loadMore" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
      <div class="balance-list-item" v-for="(item, index) in dataList" :key="index" @click="checkDetail(item.ID)">
        <div class="leftPart">
          <van-image class="goodsPic" :src="item.PicUrl" />
          <div class="subRight">
            <div class="titleShort oneRow" v-text="item.TitleShort"></div>
            <div class="time">{{ item.CreateTime | formatDay }}</div>
          </div>
        </div>
        <div class="rightPart">
          <div
            :class="
              classFilter({
                OptMoney: item.OptMoney,
                OptAmountBack: item.OptAmountBack
              })
            "
            class="optAmountBack"
          >
            {{ item.OptMoney | priceFilter(item.OptAmountBack) }}
          </div>
          <span class="oneRow remark">{{ item | descFilter }}</span>
        </div>
      </div>
    </div>
    <!-- no more -->
    <segement-Line v-if="!haveMore" line-text="没有更多明细了"> </segement-Line>
    <segement-Line v-else :is-load="true"> </segement-Line>
  </div>
</template>

<script>
import SegementLine from '@/components/puppetComponent/SegementLine'
import ShSearch from '@/components/smartComponent/SHsearch'
import { Toast, Indicator } from 'mint-ui'
import numeral from 'numeral'
import moment from 'moment'
import Utils from '@/utils/base'
import { AmountBackListGet } from '@/api/my'

export default {
  data() {
    return {
      haveMore: true,
      selectTypeShow: false,
      scrollDisabled: false,
      radioSelect: '0',
      isClickSearch: false,
      radioOptions: [{ label: '订单编号', value: '0' }],
      // 是余额进入还是待返金额进入（0：余额）
      entoType: 0,
      dataList: [],
      PlatformOrderID: '',
      tradeID: '',
      currentPage: 1,
      page: 1,
      pageCount: 1
    }
  },
  components: {
    SegementLine,
    ShSearch
  },
  mounted() {
    this.entoType = this.$route.query.type ? parseInt(this.$route.query.type) : 0
    this.PlatformOrderID = this.$route.query.PlatformOrderID ? this.$route.query.PlatformOrderID : ''
    this.fetchData()
  },
  methods: {
    fetchData() {
      let params = {}
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      params = {
        PlatformOrderID: this.PlatformOrderID,
        page: this.currentPage
      }
      // 获取待返金额列表
      AmountBackListGet(params)
        .then((res) => {
          Indicator.close()
          this.setResData(res)
          this.scrollDisabled = false
        })
        .catch((res) => {
          Indicator.close()
          this.haveMore = false
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
        })
    },
    setResData(res) {
      this.dataList = [...this.dataList, ...res.DataList]
      this.page = res.PaginationViewModel.Page
      this.pageCount = res.PaginationViewModel.PageCount
      if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
        this.haveMore = false
      }
    },
    // 搜索取消
    searchCancel() {
      this.selectTypeShow = false
      if (this.isClickSearch) {
        this.isClickSearch = false
        this.dataList = []
        this.currentPage = 1
        this.PlatformOrderID = ''
        this.tradeID = ''
        this.fetchData()
      }
    },
    // 搜索提交
    submitSearch(val) {
      if (!val) {
        Toast('请输入编号')
        return
      }
      if (parseInt(this.radioSelect)) {
        this.PlatformOrderID = ''
        this.tradeID = val
      } else {
        this.PlatformOrderID = val
        this.tradeID = ''
      }
      this.selectTypeShow = false
      this.dataList = []
      this.currentPage = 1
      this.isClickSearch = true
      this.fetchData()
    },
    // 查看明细
    checkDetail(id) {
      this.$router.push({
        name: 'balanceDetail',
        query: {
          id: id,
          type: this.entoType
        }
      })
    },
    // 加载更多
    loadMore() {
      let { page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage += 1
      this.haveMore = true
      this.fetchData()
    },
    classFilter({ OptMoney, OptAmountBack }) {
      let className = ''
      if (OptMoney !== undefined) {
        className = OptMoney > 0 ? `increase` : 'reduce'
      } else if (OptAmountBack !== undefined) {
        className = OptAmountBack > 0 ? `increase` : 'reduce'
      }
      return className
    }
  },
  filters: {
    formatMoneyStutas(value) {
      return numeral(value).format('0,0.00')
    },
    formatDay(val) {
      let isRight = Utils.isYesOrToday(val)
      if (isRight === false) {
        return moment(val).format('YYYY-MM-DD')
      } else {
        return moment(val).format('HH:mm')
      }
    },
    priceFilter(OptMoney, OptAmountBack) {
      let tempNum = 0
      if (OptMoney !== undefined) {
        tempNum = OptMoney > 0 ? `+${OptMoney.toFixed(2)}` : OptMoney.toFixed(2)
      } else if (OptAmountBack !== undefined) {
        tempNum = OptAmountBack > 0 ? `+${OptAmountBack.toFixed(2)}` : OptAmountBack.toFixed(2)
      }
      return tempNum
    },
    descFilter(item) {
      let tempStr = ''
      if (item.OptMoney !== undefined) {
        if (item.OptMoney > 0) {
          tempStr = item.TransferAccountsStatus === 2 ? '提现失败，返还金额' : `余额增加-${item.OptContent}`
        } else {
          tempStr = `余额减少-${item.OptContent}`
        }
      } else if (item.OptAmountBack !== undefined) {
        if (item.OptAmountBack > 0) {
          tempStr = '待返金额增加-特卖购买'
        } else {
          // BackType 试用返还 = 0, 特卖返还 = 1, 订单退款 = 2
          switch (item.BackType) {
            case 1:
              tempStr = '待返金额减少-成功返款'
              break
            case 2:
              tempStr = '待返金额减少-订单已退款'
              break
            case 3:
              tempStr = '特卖金额减少-扣减首单礼金或其他优惠'
              break
          }
        }
      }
      return tempStr
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  font-size: 13px;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
}
.balance-cnt {
  background: #f5f5f5;
}
/* search bar */
.search-bar {
  position: relative;
}
.search-bar .mint-search {
  height: 100%;
}
.search-bar .search-type {
  position: fixed;
  top: 52px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.search-type .radio-group {
  z-index: 1000;
}
.radio-group >>> .mint-radiolist-title {
  display: none;
}
.search-type .mask {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}
/* list mian */
.balance-mian {
  background: #fff;
  box-sizing: border-box;
}
.balance-list-item {
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 74px;
  padding: 3% 3%;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  .leftPart {
    display: flex;
    max-width: 60%;
    .goodsPic {
      width: 50px;
      height: 50px;
      flex-shrink: 0;
      border-radius: 3px;
      overflow: hidden;
    }
    .subRight {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 8px;
      height: 50px;
      margin-right: 20px;
      .titleShort {
        font-size: 14px;
        line-height: 1.5em;
        max-height: 1.5em;
      }
      .time {
        font-size: 13px;
        color: #a09f9a;
        line-height: 1.5em;
        max-height: 1.5em;
      }
    }
  }
  .rightPart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    height: 50px;
    align-items: flex-end;
    .optAmountBack {
      font-size: 15px;
      line-height: 1.5em;
      max-height: 1.5em;
      &.increase {
        color: #ec0536;
      }
      &.reduce {
        color: #000;
      }
    }
    .remark {
      font-size: 12px;
      line-height: 1.5em;
      max-height: 1.5em;
      color: #a09f9a;
    }
  }
}
</style>
